// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1218":"css/admin-app.6809","1641":"css/app.6809"}[chunkId] + ".css";
};